import { apiUrl } from '@/shared/api/client';
import { getCurrentRole } from '@/shared/session/roleStore';
import { askEventSchema, type AskEvent } from './schemas';

export type HistoryTurn = { question: string; answer: string };

/** Streams POST /ask. Axios cannot read a streaming body in the browser, so this uses fetch. */
export async function streamAsk(
  /** documentId: Ask on a report page, answered from that report alone. */
  body: { question: string; history: HistoryTurn[]; documentId?: string },
  onEvent: (event: AskEvent) => void,
  signal: AbortSignal,
): Promise<void> {
  const res = await fetch(apiUrl('/ask'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream', 'X-Demo-Role': getCurrentRole() },
    body: JSON.stringify(body),
    signal,
  });
  if (!res.ok || !res.body) throw new Error(`Ask failed with status ${res.status}`);

  const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
  let buffer = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += value;
    const frames = buffer.split('\n\n');
    buffer = frames.pop() ?? '';
    frames.map(parseFrame).forEach((evt) => { if (evt) onEvent(evt); });
  }
}

function parseFrame(frame: string): AskEvent | null {
  const event = /^event: (.+)$/m.exec(frame)?.[1];
  const data = /^data: (.+)$/m.exec(frame)?.[1];
  if (!event || !data) return null;
  const parsed = askEventSchema.safeParse({ event, data: JSON.parse(data) as unknown });
  return parsed.success ? parsed.data : null;
}
